import { COOKIE_PORTAL_ID_NAME } from '../../constants/constants';
import seonApi from '../../../../api/seon-api';
import Vue, { ref } from 'vue';
export const useSeon = () => {
	const seonData = ref(null);
	const initSeon = () => {
		return new Promise((resolve, reject) => {
			const portalIdCookie = Vue.cookie.get(COOKIE_PORTAL_ID_NAME);
			if (portalIdCookie) {
				const portalIdSanitized = portalIdCookie.replace(/-/g, '');
				/* eslint-disable camelcase */
				window.seon.config({
					// public_key: '[public_key]',
					session_id: portalIdSanitized,
					audio_fingerprint: true,
					canvas_fingerprint: true,
					webgl_fingerprint: true,
					endpoint: {
						session: '/apps/seon/api/seon/'
					},
					onSuccess: resolve,
					onError: reject
				});
				/* eslint-enable camelcase */
			} else {
				resolve();
			}
		});
	};
	const startSeon = () => {
		return new Promise((resolve, reject) => {
			const portalIdCookie = Vue.cookie.get(COOKIE_PORTAL_ID_NAME);
			if (portalIdCookie) {
				window.seon.saveSession(async (success) => {
					if (success) {
						try {
							const portalIdSanitized = portalIdCookie.replace(/-/g, '');
							const response = await seonApi.getSeonData(portalIdSanitized);
							resolve(response.data);
						} catch (err) {
							reject();
						}
						resolve();
					} else {
						reject();
					}
				});
			} else {
				reject();
			}
		});
	};
	const getSeonData = async () => {
		try {
			await initSeon();
			seonData.value = JSON.stringify(await startSeon());
		} catch (err) {
			console.error('Seon is not available');
		}
	};
	getSeonData();
	return {
		seonData
	};
};
